import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const MoveToTransferEvent = BaseLoanEvent.extend({
  type: z.literal('moveToTransfer'),
});
export type MoveToTransferEvent = z.infer<typeof MoveToTransferEvent>;
